import { mapResponsiveStyles, type Types } from '@fiverr-private/theme';
import type { ModalContentProps } from '../types';
import { DIALOG_WIDTH } from './constants';

export const getConditionalSize = (size: ModalContentProps['size']): Types.ResponsiveWidthType => {
    if (typeof size === 'object') {
        return mapResponsiveStyles(size, (value) => DIALOG_WIDTH[value as string]);
    }

    return DIALOG_WIDTH[size || 'md'];
};
